import { useQueryClient } from 'react-query';

import { queryKey } from '../../paragraphs.query-keys';

export const useInvalidateAllParahraphs = () => {
    const queryClient = useQueryClient();

    return () => {
        queryClient.invalidateQueries(queryKey.paragraphs());
    };
};
